<template>
    <div class="global-network">
        <div class="visual">
            <Visual :title="'GLOBAL NETWORK'"/>
        </div>
        <div class="content" id="content">
            <div class="shape-wrapper" v-if="$resize && $mq.above(1024)">
                <div class="shape1"  v-parallax="0.2"></div>
                <div class="shape2"  v-parallax="0.4"></div>
                <div class="shape3"  v-parallax="-0.2"></div>
            </div>
            <Scrollama @step-enter="setVisible" :offset="0.75">
                <div v-for="(item, index) in centers"
                    :key="index"
                    class="center">
                    <div :id="item" class="top-point"></div>
                    <p class="title" v-html="$t(`globalnetwork.section01.center0${(index + 1)}.title`)"></p>
                    <p class="desc" v-html="$t(`globalnetwork.section01.center0${(index + 1)}.desc`)"></p>
                </div>
            </Scrollama>
        </div>
    </div>
</template>

<script>
import 'intersection-observer'
import Scrollama from 'vue-scrollama'
import Visual from '@/components/globalnetwork/Visual'
export default {
    name: 'GlobalNetwork',
    components: { Scrollama, Visual },
    metaInfo: {
        titleTemplate: '%s | GLOBAL NETWORK',
        meta: [
            { name: 'description', content: '혁신적인 글로벌 이커머스 서비스의 중심, 큐브플랫폼' },
            { name: 'property="og:description"', content: '혁신적인 글로벌 이커머스 서비스의 중심, 큐브플랫폼' }
        ]
    },
    data: function () {
        return {
            centers: ['kr', 'jp', 'de', 'uk']
        }
    },
    methods: {
        setVisible: function (el) {
            el.element.classList.add('is-active')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/mixin.scss';
@include over-desktop {
    .content {
        width: 100%;
        text-align: center;
        .shape-wrapper {
            position: relative;
            width: 1200px;
            height: 100%;
            z-index: -1;
            margin: 0 auto;
            .shape1 {
                position: absolute;
                top: -100px;
                right: -6%;
                width: 339px;
                height: 290px;
                background: url(../assets/image/globalnetwork/shape_01.png) no-repeat center;
                background-size: 100% auto;
            }
            .shape2 {
                position: absolute;
                top: 500px;
                left: 10%;
                width: 127px;
                height: 117px;
                background: url(../assets/image/globalnetwork/shape_02.png) no-repeat center;
                background-size: 100% auto;
            }
            .shape3 {
                position: absolute;
                top: 1000px;
                right: 15%;
                width: 50px;
                height: 58px;
                background: url(../assets/image/globalnetwork/shape_03.png) no-repeat center;
                background-size: 100% auto;
            }
        }
        .title {
            color: #444;
            font-size: 28px;
            line-height: 28px;
            letter-spacing: -1px;

            &::before {
                content: '';
                display: block;
                width: 72px;
                height: 10px;
                margin: 0 auto 20px;
                background: url(../assets/image/common/before-title.svg) no-repeat center;
                background-size: 100% auto;
            }
        }
        .desc {
            margin-top: 50px;
            color: #999;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: -1px;;
        }
        .center {
            position: relative;
            padding: 100px 0;
            border-top: 1px solid #dbdbdb;

            &:first-child {
                border-top: none;
            }
            .top-point {
                position: absolute;
                top: -90px;
                width: 0;
                height: 0;
            }
        }
    }
    .center {
        .title {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1000ms, transform 1000ms;
        }
        .desc {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 1000ms 150ms, transform 1000ms 150ms;
        }
    }
    .center.is-active {
        .title {
            opacity: 1;
            transform: translateY(0);
        }
        .desc {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include desktop-small {
    .content {
        .shape-wrapper {
            width: 1024px;
        }
    }
}
@include under-tablet {
    .content {
        .center {
            position: relative;
            padding: 14vw 0;
            border-bottom: 1px solid #dbdbdb;
            text-align: center;
            .top-point {
                position: absolute;
                top: -80px;
                width: 0;
                height: 0;
            }
            .title {
                color: #444;
                font-size: 5.2vw;
                letter-spacing: -0.2vw;

                &::before {
                    content: '';
                    display: block;
                    margin: 0 auto 4vw;
                    width: 20vw;
                    height: 3vw;
                    background: url(../assets/image/common/before-title.svg) no-repeat center;
                    background-size: 100% auto;
                }
            }
            .desc {
                margin-top: 6vw;
                color: #999;
                font-size: 3.4vw;
                letter-spacing: -0.2vw;
            }
        }
    }
    .center {
        .title {
            opacity: 0;
            transform: translateY(4vw);
            transition: opacity 1000ms, transform 1000ms;
        }
        .desc {
            opacity: 0;
            transform: translateY(4vw);
            transition: opacity 1000ms 150ms, transform 1000ms 150ms;
        }
    }
    .center.is-active {
        .title {
            opacity: 1;
            transform: translateY(0);
        }
        .desc {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
@include mobile {
    .content {
        .center {
            .top-point {
                top: -64px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/GlobalNetwork.vue